import _axios from '@/plugins/axios'
import store from '@/store'
// 在任何地方使用
import urlParam, { url_to_query } from '@/plugins/getUrlParam'
import { APPLET_HOST, MINIMAX_HOST, STATIC_HOST } from '@/api/constants'
import { readTime } from '@/utils/timerUtil'
// 120服务器域名地址 https://test.aigcpop.com:443/api/
// 120服务器IP地址 // http://120.26.103.140:6060/
// 谢本地地址 'http://192.168.8.103:6060/'
// 原来代码地址 'https://test.aigcpop.com:443/api/'
// 正式环境地址 'https://dt.aigcpop.com/api/'
// 前端代理'api/'

const preUrl = STATIC_HOST
const appletUrl = APPLET_HOST
// export const getAppToken = () => {
//   if (!store?.state?.vuex_app_phone) {
//     return Promise.reject({ msg: "缺少手机号" });
//   }
//   if (!store?.state?.vuex_app_password) {
//     return Promise.reject({ msg: "缺少密码" });
//   }
//   return new Promise((resolve, reject) => {
//     _axios({
//       url: preUrl+"user/login",
//       method: "post",
//       data: {
//         identity: store?.state?.vuex_app_phone,
//         password: store?.state?.vuex_app_password,
//       },
//       headers: {
//         "Content-Type": "application/json",
//       },
//     })
//       .then((res) => {
//         if (res?.status != "ok") {
//           return reject(res);
//         }
//         return resolve(res);
//       })
//       .catch((error) => {
//         return reject(error);
//       });
//   });
// };

export const getH5Token = () => {
  console.warn('getH5Token will get urlParam:', urlParam)

  // url_to_query 太早运行，urlParam中会有问题（漏符号），用的时候再单独跑一次
  const params = url_to_query() || {}



  if (!params?.identity && !params?.native && !params?.state) {
    return Promise.reject({ msg: '缺少身份' })
  }
  let dataObj = {
    weiXinMark: false
  }
  if (params?.follow_state){
    dataObj.weiXinMark = true // weiXinMark用于是否小程序在 false为H5网页中;小程序用户是否已登录为user_token的存在且不为空
  }
  console.log('weiXinMark:', dataObj.weiXinMark)

  const doIdentity = (identity)=>{
    // 由于url中返回参数的 +号被转义成 %20，其实应该是 %2B，后台再次反转义 %20会转成 空格


    return new Promise((resolve, reject) => {
      _axios({
        url: preUrl + 'user/h5_token',
        method: 'post',
        data: {
          // identity:
          //   "w/33H0LSmtWlcOoxDhKd6lbkuc9yKtl2MmxB9mpnm33QCl+qw6tw0Hpsx9A0FEutffIG5q2/DQRGHJYgXCDzwIpTO4bghEYi3HVMx4yBgvE=",
          "identity": identity
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then((res) => {
          if (res?.status !== 'ok') {
            return reject(res)
          }
          return resolve(res)
        })
        .catch((error) => {
          return reject(error)
        })
    })
  }

  if (params?.native){
    dataObj.access_token = params?.native
    const appTokenRes = {
      data: dataObj
    }
    return appTokenRes

  } else if(params?.code && params?.state){
    const _stateStr = params?.state
    const stateStr = decodeURIComponent(_stateStr)
    try {
      const stateObject = JSON.parse(stateStr)
      if(stateObject?.native && stateObject?.native !== ''){
        dataObj.access_token = stateObject?.native
        const appTokenRes = {
          data: dataObj
        }
        return appTokenRes
      }

      if(stateObject?.identity){
        const identity = stateObject?.identity
        return doIdentity(identity)
      }

    } catch (error){
      console.error("pares json stateStr error", error);
    }
  }
  else {
    const formatIdentity = (params?.identity || '').replace(/%20/g, '%2B')

    const identity = decodeURIComponent(formatIdentity)
    // const identity = formatIdentity;
    // const identity = decodeURI(params?.identity);
    console.warn(
      '🚀 ~ file: app.js:41 ~ getH5Token ~ params?.identity : ',
      identity
    )
    return doIdentity(identity)
  }

}

export const getH5TokenCopyOldWay = () => {
  console.warn('urlParam 1', urlParam)

  // url_to_query 太早运行，urlParam中会有问题（漏符号），用的时候再单独跑一次
  const params = url_to_query() || {}
  if (!params?.identity && !params?.native) {
    return Promise.reject({ msg: '缺少身份' })
  }
  console.warn('urlParam 1      ', urlParam)
  // const a =
  //   "w/33H0LSmtWlcOoxDhKd6hy66W7S3zpTpjzuKCmeePh11jfri0P1lg4mfARQgwUL3mLWAVI1O3oG4clL0ftFHQJP89Z8LZQmhzuxLeXUJto=";
  // console.warn("urlParam 2      ", urlParam);
  // console.warn("params          ", params);
  // console.warn("window.location          ", window.location);

  // console.warn("原始文本          ", a);
  // console.warn("浏览器自转义解析  ", decodeURIComponent(params?.identity));
  // console.warn("浏览器自动转义    ", params?.identity);
  // console.warn("js转义            ", encodeURIComponent(a));

  // 由于url中返回参数的 +号被转义成 %20，其实应该是 %2B，后台再次反转义 %20会转成 空格
  const formatIdentity = (params?.identity || '').replace(/%20/g, '%2B')

  const identity = decodeURIComponent(formatIdentity)
  // const identity = formatIdentity;
  // const identity = decodeURI(params?.identity);
  console.warn(
    '🚀 ~ file: app.js:41 ~ getH5Token ~ params?.identity : ',
    identity
  )

  return new Promise((resolve, reject) => {
    _axios({
      url: preUrl + 'user/h5_token',
      method: 'post',
      data: {
        // identity:
        //   "w/33H0LSmtWlcOoxDhKd6lbkuc9yKtl2MmxB9mpnm33QCl+qw6tw0Hpsx9A0FEutffIG5q2/DQRGHJYgXCDzwIpTO4bghEYi3HVMx4yBgvE=",
        "identity": identity
      },
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        if (res?.status !== 'ok') {
          return reject(res)
        }
        return resolve(res)
      })
      .catch((error) => {
        return reject(error)
      })

    //preUrl +
    /* axios.post(
       'api/' + 'user/h5_token',
      {
        identity: identity
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Credentials': true,
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
        },
        withCredentials: false,
      },
    ).then(
      (res) => {
        //执行成功后代码处理
        if (res?.status !== 'ok') {
          console.log('sssssssssssssss ok')
          return reject(res)
        }
        return resolve(res)
      }
    ) */

    // xhr方法
    /* const xhr = new XMLHttpRequest();
    const data = {
      identity: identity
    }; // 替换为你的 JSON 格式请求体数据

    xhr.open('POST', preUrl + 'user/h5_token', true);
    xhr.setRequestHeader('Content-Type', 'application/json'); // 设置请求头为 JSON 格式
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && xhr.status === 200) {
        const response = JSON.parse(xhr.responseText);
        // 处理响应
      }
    };
    xhr.onerror = function() {
      // 处理请求错误
    };
    xhr.send(JSON.stringify(data)); */

    // get 请求
    /* axios.get(preUrl + 'media/avatar_templates', {//preUrl + 'user/user/info' //https://test.aigcpop.com/api/media/avatar_templates
       params: {
        phone: '18811111113',
        start: '0',
        limit: '10'
      },
      //withCredentials: false,
      headers: {
        'Authorizations': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTcwMjI2MjgxNiwianRpIjoiOGQ0YzNlZTQtZjUzNS00ZDg4LTljZTMtMTYwZDJmN2U1NjFjIiwidHlwZSI6ImFjY2VzcyIsInN1YiI6IjE4ODExMTExMTEzfHVzZXIiLCJuYmYiOjE3MDIyNjI4MTYsImV4cCI6MTcwNDg1NDgxNn0.Aj3XloPdg-By6YfVBBemQ33Vv4r01mT5bR6pKEA1NOg'
      }
    })
      .then(response => {
        // 处理响应
        const data = response.data;
        // 对返回的数据进行操作
      })
      .catch(error => {
        // 处理请求错误
      }); */

    // get 2
    /* const xhr = new XMLHttpRequest();
    const data = {
      identity: identity
    }; // 替换为你的 JSON 格式请求体数据

    xhr.open('GET', "http://192.168.8.103:6060/media/avatar_templates", false);
    xhr.setRequestHeader('Content-Type', 'application/json'); // 设置请求头为 JSON 格式
    xhr.setRequestHeader("Authorizations", "bb eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTcwMjI2MjgxNiwianRpIjoiOGQ0YzNlZTQtZjUzNS00ZDg4LTljZTMtMTYwZDJmN2U1NjFjIiwidHlwZSI6ImFjY2VzcyIsInN1YiI6IjE4ODExMTExMTEzfHVzZXIiLCJuYmYiOjE3MDIyNjI4MTYsImV4cCI6MTcwNDg1NDgxNn0.Aj3XloPdg-By6YfVBBemQ33Vv4r01mT5bR6pKEA1NOg") // 设置请求头为 JSON 格式
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && xhr.status === 200) {
        const response = JSON.parse(xhr.responseText);
        // 处理响应
      }
    };
    xhr.onerror = function() {
      // 处理请求错误
    };
    xhr.send(JSON.stringify(data)); */



    // login 测试

    /* axios.post(
      preUrl + 'user/login',
      {
        "identity": "18811111113",
        "password": "111111"
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Credentials': true,
          'Access-Control-Allow-Origin': 'https://test.aigcpop.com',
          'Access-Control-Allow-Headers': '*',
        },
      },

    ).then(
      (res) => {
        //执行成功后代码处理
        if (res?.status !== 'ok') {
          console.log('sssssssssssssss ok')
          return reject(res)
        }
        return resolve(res)
      }
    ) */
    // 原来的衍变
    /* _axios({
     url: preUrl + 'user/h5_token',
     method: 'post',
     data: {identity:identity},
     // 跨域相关
     headers: {
       'Content-Type': 'application/json',
       'Access-Control-Allow-Credentials': true,
       'Access-Control-Allow-Origin': 'http://localhost:8802/',
       'Access-Control-Allow-Headers': '*',
       'Access-Control-Allow-Methods': '*'
     }
   })
     .then((res) => {
       if (res?.status !== 'ok') {
         return reject(res)
       }
       return resolve(res)
     })
     .catch((error) => {
       return reject(error)
     }) */

  })
}

export const getProjectList = () => {
  // if (!store?.state?.vuex_app_phone) {
  //   return Promise.reject({ msg: "缺少手机号" });
  // }
  return new Promise((resolve, reject) => {
    _axios({
      url: preUrl + 'project/list',
      method: 'post',
      data: {
        //  phone: store?.state?.vuex_app_phone
      },
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        if (res?.status != 'ok') {
          return reject(res)
        }
        return resolve(res)
      })
      .catch((error) => {
        return reject(error)
      })
  })
}

export const getCommodityList = () => {
  if (!store?.state?.vuex_app_user_info?.phone) {
    return Promise.reject({ msg: '缺少手机号' })
  }
  const id = String(store?.state?.vuex_app_project_data?.id)
  if (id == 'undefined') {
    return Promise.reject({ msg: '缺少项目ID' })
  }
  return new Promise((resolve, reject) => {
    _axios({
      url: preUrl + 'commodity/commodity_list',
      method: 'get',
      params: {
        phone: store?.state?.vuex_app_user_info?.phone,
        project_id: id
      }
    })
      .then((res) => {
        if (res?.status != 'ok') {
          return reject(res)
        }
        return resolve(res)
      })
      .catch((error) => {
        return reject(error)
      })
  })
}

export const getGreetChat = (appletToken) => {
  return new Promise((resolve, reject) => {
    _axios({
      url: preUrl + 'agent_greet_chat',
      method: 'post',
      headers: {
        'USER-TOKEN': appletToken
      },
      data: { chat_type: 'h5' },
    })
      .then((res) => {
        if (res?.status != 'ok') {
          return reject(res)
        }
        return resolve(res)
      })
      .catch((error) => {
        return reject(error)
      })
  })
}
export const getCardInfo = () => {
  return new Promise((resolve, reject) => {
    _axios({
      url: preUrl + 'user/h5_activity_record',
      method: 'get',
      params: {
      }
    })
      .then((res) => {
        if (res?.status != 'ok') {
          return reject(res)
        }
        return resolve(res)
      })
      .catch((error) => {
        return reject(error)
      })
  })
}
export const getUserVideoInfo = () => {
  return new Promise((resolve, reject) => {
    _axios({
      url: preUrl + 'user/personal_video',
      method: 'get',
      params: {
      }
    })
      .then((res) => {
        if (res?.status != 'ok') {
          return reject(res)
        }
        return resolve(res)
      })
      .catch((error) => {
        return reject(error)
      })
  })
}
export const getUserInfo = () => {
  // if (!store?.state?.vuex_app_phone) {
  //   return Promise.reject({ msg: "缺少手机号" });
  // }

  return new Promise((resolve, reject) => {
    _axios({
      url: preUrl + 'user/info',
      method: 'get',
      params: {
        // phone: store?.state?.vuex_app_phone,
        start: 0,
        limit: 10
      }
    })
      .then((res) => {
        if (res?.status != 'ok') {
          return reject(res)
        }
        return resolve(res)
      })
      .catch((error) => {
        return reject(error)
      })
  })
}

export const getTtsInfo = () => {

  return new Promise((resolve, reject) => {
    _axios({
      url: preUrl + 'voice/get_access_token',
      method: 'get',
      params: {}
    })
      .then((res) => {
        console.log('api getTtsInfo res:', res)
        if (res?.status != 'ok') {
          return reject(res)
        }
        return resolve(res)
      })
      .catch((error) => {
        return reject(error)
      })
  })
}

export const getVideoInfo = () => {
  return new Promise((resolve, reject) => {
    _axios({
      url: preUrl + 'user/face_fusion_video',
      method: 'get',
      params: {
      }
    })
      .then((res) => {
        if (res?.status !== 'ok') {
          return reject(res)
        }
        return resolve(res)
      })
      .catch((error) => {
        return reject(error)
      })
  })
}
export const getWeixinMark = () => {
  return store.state.weiXinMark
}

export const feedback = (data) => {
  /* const id = String(store?.state?.vuex_app_project_data?.id)
  if (id == 'undefined') {
    return Promise.reject({ msg: '缺少项目ID' })
  } */
  const targetPhone = String(store?.state?.vuex_app_user_info?.phone)
  if (targetPhone === 'undefined') {
    return Promise.reject({ msg: '缺少目标智能体手机号' })
  }
  return new Promise((resolve, reject) => {
    _axios({
      url: preUrl + 'user/feedback',
      method: 'post',
      data: {
        // project: id,
        user_phone: targetPhone,
        ...data },
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        if (res?.status != 'ok') {
          return reject(res)
        }
        return resolve(res)
      })
      .catch((error) => {
        return reject(error)
      })
  })
}

export const askApi = (text = '') => {
  if (!text) {
    return Promise.reject({ msg: '缺少必备参数' })
  }
  if (!store?.state?.vuex_app_user_info?.phone) {
    return Promise.reject({ msg: '缺少手机号' })
  }
  if (!store?.state?.vuex_app_project_data) {
    return Promise.reject({ msg: '缺少项目数据' })
  }
  const id = String(store?.state?.vuex_app_project_data?.id)
  if (id == 'undefined') {
    return Promise.reject({ msg: '缺少项目ID' })
  }
  return new Promise((resolve, reject) => {
    _axios({
      url: preUrl + 'h5_chat',
      method: 'post',
      data: {
        phone: store?.state?.vuex_app_user_info?.phone,
        project: id,
        question: text
      },
      headers: {
        'Content-Type': 'application/json'
      },
      timeout: 1000 * 30
    })
      .then((res) => {
        if (res?.status != 'ok') {
          return reject(res)
        }
        return resolve(res)
      })
      .catch((error) => {
        return reject(error)
      })
  })
}

export const askApiStream = (text = '') => {
  if (!text) {
    return Promise.reject({ msg: '缺少必备参数' })
  }

  const id = String(store?.state?.vuex_app_project_data?.id)
  if (id == 'undefined') {
    return Promise.reject({ msg: '缺少项目ID' })
  }

  return new Promise((resolve, reject) => {
    _axios({
      url: preUrl + 'chat-stream',
      method: 'post',
      data: {
        history: [],
        project_id: id,
        project_name: store?.state?.vuex_app_project_data?.name,
        question: text
      },
      headers: {
        'Content-Type': 'text/event-stream',
        'Cache-Control': 'no-cache',
        Connection: 'keep-alive'
      },
      timeout: 1000 * 30
    })
      .then((res) => {
        if (res?.status != 'ok') {
          return reject(res)
        }
        return resolve(res)
      })
      .catch((error) => {
        return reject(error)
      })
  })
}


export const like = (params, userToken) => {

  return new Promise((resolve, reject) => {
    _axios({
      url: appletUrl + 'like',
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'application/json',
        'user-token': userToken

      }
    })
      .then((res) => {
        if (res?.code !== 200) {
          return reject(res)
        }
        return resolve(res)
      })
      .catch((error) => {
        return reject(error)
      })
  })
}

export const unlike = (params, userToken) => {

  return new Promise((resolve, reject) => {
    _axios({
      url: appletUrl + 'unlike',
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'application/json',
        'user-token': userToken
      }
    })
      .then((res) => {
        if (res?.code !== 200) {
          return reject(res)
        }
        return resolve(res)
      })
      .catch((error) => {
        return reject(error)
      })
  })
}


export const follow = (params, userToken) => {

  return new Promise((resolve, reject) => {
    _axios({
      url: appletUrl + 'follow',
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'application/json',
        'user-token': userToken

      }
    })
      .then((res) => {
        if (res?.code !== 200) {
          return reject(res)
        }
        return resolve(res)
      })
      .catch((error) => {
        return reject(error)
      })
  })
}

export const unfollow = (params, userToken) => {

  return new Promise((resolve, reject) => {
    _axios({
      url: appletUrl + 'unfollow',
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'application/json',
        'user-token': userToken
      }
    })
      .then((res) => {
        if (res?.code !== 200) {
          return reject(res)
        }
        return resolve(res)
      })
      .catch((error) => {
        return reject(error)
      })
  })
}

export const appletMark = (userToken) => {

  return new Promise((resolve, reject) => {
    _axios({
      url: appletUrl + 'mark',
      method: 'post',
      data: {},
      headers: {
        'Content-Type': 'application/json',
        'user-token': userToken

      }
    })
      .then((res) => {
        if (res?.code !== 200) {
          return reject(res)
        }
        return resolve(res)
      })
      .catch((error) => {
        return reject(error)
      })
  })
}

export const getSunImage = (userToken) => {

  return new Promise((resolve, reject) => {
    _axios({
      url: preUrl + '/user/share_qrcode',
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        'user-token': userToken

      }
    })
      .then((res) => {
        if (res?.status != 'ok') {
          return reject(res)
        }
        return resolve(res)
      })
      .catch((error) => {
        return reject(error)
      })
  })
}

export const apiSendViewHistory = (params) => {
  return new Promise((resolve, reject) => {
    _axios({
      url: preUrl + 'mall_commodity/browse',
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        if (res?.status != 'ok') {
          return reject(res)
        }
        return resolve(res)
      })
      .catch((error) => {
        return reject(error)
      })
  })
}
// _promise
/* res.text = params.text
         return resolve(res) */ // return

/* try {
  let hexString = res?.data.audio
  let result = [];
  for (let i = 0; i < hexString.length; i += 2) {
    result.push(parseInt(hexString.substr(i, 2), 16));
  }
  let blob = new Blob([new Uint8Array(result)], { type: 'audio/mp3' }); // wav mp3
  let url = (window.URL || window.webkitURL || window || {}).createObjectURL(blob);
  console.log('blob url:', url);
  return resolve(url); // res // 将 blob URL 作为 Promise 的结果进行解析
} catch (error) {
  reject(error); // 如果出现错误，则将错误传递给 Promise 的 reject 方法
} */
export const apiT2A_promise = async (params, groupId, token) => {

  return new Promise((resolve, reject) => {
    _axios({
      url: MINIMAX_HOST + '/v1/t2a_v2?GroupId=' + groupId,
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + token
      }
    })
      .then((res) => {
        if (res?.base_resp?.status_code == 0) {
          processData(res?.data.audio).then(url => {
             resolve({
               url: url,
               text: params.text
             });
          })
        } else {
          reject(res) // return
        }
      })
      .catch((error) => {
        return reject(error) // return
      })
  })
}

export const apiT2A_order = async (params, groupId, token) => {
  try {
    const res = await _axios({
      url: MINIMAX_HOST + '/v1/t2a_v2?GroupId=' + groupId,
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + token
      }
    })
    if (res?.base_resp?.status_code == 0) {
      const res2 = await processData_await(res?.data.audio)
      console.log('res2:', res2)
      return res2
    } else {
      return (res) // return
    }
    /* const response = await _axios({
      url: MINIMAX_HOST + '/v1/t2a_v2?GroupId=' + groupId,
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + token
      }
    }).then((res) => {
        console.log('apiT2A_promise apiT2A response', res)
        if (res?.base_resp?.status_code == 0) {
          processData(res?.data.audio).then(url => {
            return resolve(url);
          })
        } else {
          return reject(res) // return
        }
    }).catch((error) => {
      return reject(error) // return
    })
    console.log('response response response', response) */


  } catch (error) {
    results.push({ error: error.message });
  }

}


export const apiT2A_promise_array = async (params, groupId, token, index) => {
  return new Promise((resolve, reject) => {
    _axios({
      url: MINIMAX_HOST + '/v1/t2a_v2?GroupId=' + groupId,
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + token
      }
    })
      .then((res) => {
        if (res?.base_resp?.status_code === 0) {
          if (res?.data.audio !== ''){
            // console.log('T start processData', readTime())
            processData(res?.data.audio).then(url => {
              return resolve({
                url: url,
                text: params.text,
                index: index
              });
              // console.log('T finish processData', readTime())
            })
          }
        } else {
          return reject({
            url: '',
            text: 'error tts',
            index: index
          }) // return
        }
      })
      .catch((error) => {
        return reject({
          url: '',
          text: 'error tts' + error.getMessage() || error,
          index: index
        }) // return
      })
  })
}

const processData_await = async (hexString) => {
  let result = [];
  for (let i = 0; i < hexString.length; i += 2) {
    result.push(parseInt(hexString.substr(i, 2), 16));
  }
  let blob = new Blob([new Uint8Array(result)], { type: 'audio/mp3' });
  let url = (window.URL || window.webkitURL || window || {}).createObjectURL(blob);
  return url;
}

export const processData = (hexString) => {
  return new Promise((resolve, reject) => {
    try {
      let result = [];
      for (let i = 0; i < hexString.length; i += 2) {
        result.push(parseInt(hexString.substr(i, 2), 16));
      }
      let blob = new Blob([new Uint8Array(result)], { type: 'audio/mp3' }); // wav mp3
      let url = (window.URL || window.webkitURL || window || {}).createObjectURL(blob);
      // console.log('processData blob url:', url);
      resolve(url); // 将 blob URL 作为 Promise 的结果进行解析
    } catch (error) {
      reject(error); // 如果出现错误，则将错误传递给 Promise 的 reject 方法
    }
  });
}
export const apiT2A_await = async (params, groupId, token) => {
  try {
    const response = await _axios({
      url: MINIMAX_HOST + '/v1/t2a_v2?GroupId=' + groupId,
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + token
      }
    });
    console.log('apiT2A axios params text ', params.text);
    console.log('apiT2A response', response);

    if (response?.base_resp?.status_code === 0) {
      response.text = params.text
      return response;
    } else {
      return { error: 'error' };
    }
  } catch (error) {
    return { error: 'error' };
  }
}

export const apiT2AStream = (params, groupId, token,) => {
  params.stream =  true
  return new Promise((resolve, reject) => {
    _axios({
      url: MINIMAX_HOST + '/v1/t2a_v2?GroupId=' + groupId,
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + token,
        'responseType': 'stream' // 使用了axios的responseType: 'stream'来处理流式数据
      }
    })
      .then((res) => {
        console.log('apiT2A response', res)
        if (res?.base_resp?.status_code == 0) {
          return resolve(res)
        } else {
          return reject(res)
        }

      })
      .catch((error) => {
        return reject(error)
      })
  })
}




